import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-light-svg-icons/faEyeSlash';
import { useToggleableCopyField } from 'root/src/client/web/base/ToggleableCopyField/hooks/useToggleableCopyField';
import { BaseTooltip, BaseTooltipContent, } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { twMerge } from 'tailwind-merge';
const censorText = (text) => {
    if (text.length <= 4)
        return '••••••••';
    return (text.slice(0, 2)
        + '•'.repeat(Math.min(text.length - 4, 16))
        + text.slice(-2));
};
export const ToggleableCopyField = ({ text, className, inputClassName, label, }) => {
    const { inputRef, toggleIsVisible, isVisible, onInputClick } = useToggleableCopyField(text);
    const displayValue = isVisible ? text : censorText(text);
    return (<div className={twMerge('flex flex-col gap-1', className)}>
			{label && <span className="text-xs text-placeholder">{label}</span>}
			<div className="flex gap-2 rounded">
				<BaseTooltip triggerClassName={inputClassName} tooltip={<BaseTooltipContent>Click to copy</BaseTooltipContent>}>
					<input ref={inputRef} readOnly onClick={onInputClick} className={twMerge('p-2 rounded select-all bg-dark-2 text-teal font-mono text-sm flex-grow min-w-0', inputClassName)} type="text" value={displayValue}/>
				</BaseTooltip>
				<ButtonNew type="button" className="w-10 h-10 flex flex-initial bg-dark-2 hover:bg-dark-3 duration-100 text-xs font-bold justify-center items-center rounded" onClick={toggleIsVisible}>
					<FontAwesomeIcon size="lg" icon={(isVisible ? faEye : faEyeSlash)}/>
				</ButtonNew>
			</div>
		</div>);
};
